import ShopRegions from 'utils/shop-regions';

const regions = new ShopRegions({
  useRegionFromNavigator: false,
  setSitesFromHreflangs: true,
  redirectIfHasSelected: false,
});

regions.shouldRedirect().then((shouldRedirect) => {
  if (shouldRedirect) {
    regions.doAutomaticRedirect();
  }
});

export default regions;
